module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="charts-list__empty">\n\n  <div class="charts-list__empty-header"></div>\n  <div class="charts-list__empty-body">\n\n    <div class="empty-indicator">\n\n      <div class="empty-indicator__icon"></div>\n        <h2>No sensor data.</h2>\n        <p>there is currently no sensor data to display</p>\n      </div>\n\n    </div>\n\n  </div>\n\n\n</li>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/empty.html
// module id = 425
// module chunks = 0